type PopularModel = {
  image: string;
  make: string;
  model: string;
};

export const popularModels: PopularModel[] = [
  {
    image: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/popular-models/toyota-camry.png`,
    make: 'Toyota',
    model: 'Camry'
  },
  {
    image: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/popular-models/jeep-grand-cherokee.png`,
    make: 'Jeep',
    model: 'Grand Cherokee'
  },
  {
    image: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/popular-models/tesla-model-3.png`,
    make: 'Tesla',
    model: 'Model 3'
  },
  {
    image: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/popular-models/ford-mustang.png`,
    make: 'Ford',
    model: 'Mustang'
  },
  {
    image: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/popular-models/honda-accord.png`,
    make: 'Honda',
    model: 'Accord'
  },
  {
    image: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/popular-models/dodge-challenger.png`,
    make: 'Dodge',
    model: 'Challenger'
  },
  {
    image: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/popular-models/honda-civic.png`,
    make: 'Honda',
    model: 'Civic'
  },
  {
    image: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/popular-models/nissan-altima.png`,
    make: 'Nissan',
    model: 'Altima'
  },
  {
    image: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/popular-models/ford-explorer.png`,
    make: 'Ford',
    model: 'Explorer'
  },
  {
    image: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/popular-models/chevrolet-equinox.png`,
    make: 'Chevrolet',
    model: 'Equinox'
  }
];
